import React, { Component } from 'react';
import { message } from 'antd';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';
import moment from 'moment';
import {defaultDate} from "../../../../../common/jsLibs";

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
            },
            data: [],
            datakp:[]
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const defaultDateObj = defaultDate();
        const { searchParams } = this.props;
        const{beginDateDefault,endDateDefault}=defaultDateObj;
        const {
            beginDate,
            endDate,
        } = searchParams;
        
        const beginDateSet = beginDate?beginDate:beginDateDefault;
        const endDateSet = endDate?endDate:endDateDefault;
        if(
        // ((beginDate)&&(endDate==undefined))||((beginDate==undefined)&&(endDate))
        // ||((beginDate=="")&&(endDate==undefined))||((beginDate==undefined)&&(endDate==""))
        beginDateSet>endDateSet
        ){
            message.error('请正确选择起止时间');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.home.queryApplicationAmountStatistic, {
            // offset: current,
            // limit: pageSize,
            beginDate:beginDateSet,
            endDate:endDateSet,
            ...searchParams,
        }).then(res => {
            const { list,kp_list,totalCount } = res;
            //pagination.total = totalCount;
            this.setState({
                //pagination,
                data: list,
                datakp: kp_list,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = (type) => {
        const columns = [{
            title: type=="all"?'所有合同':"开票确认收入的合同",
            dataIndex: 'columnTitle',
            key: 'columnTitle',
            width: 100,
        },{
            title: '金额合计（元）',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
            width: 60,
        },
        {
            title: '业务线',
            children: [
                {
              title: '肿瘤',
              dataIndex: 'tumourAmount',
              key: 'tumourAmount',
              width: 40,
            }, {
              title: '非肿瘤',
              dataIndex: 'notTumourAmount',
              key: 'notTumourAmount',
              width: 40,
            }, {
                title: '综合',
                dataIndex: 'comprehensiveAmount',
                key: 'comprehensiveAmount',
                width: 40,
              }, {
                title: '招募',
                dataIndex: 'recruitAmount',
                key: 'recruitAmount',
                width: 40,
              }, {
                title: 'ARO',
                dataIndex: 'aroAmount',
                key: 'aroAmount',
                width: 40,
              }
         ],
          }
    ];
        return columns;
    }

    handleChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { height } = this.props;
        const { data,datakp, loading, pagination } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    // pagination={pagination}
                    pagination={false}
                    onChange={this.handleChange}
                    columns={this.getColumns("all")}
                    className="unregisterRequest"
                    rowClassName={(record, index) => {
                        if(record.columnTitle.indexOf("合计") != -1){
                            return "bg_total";
                        }
                    }}
                />

                <TableC //开票
                    data={datakp}
                    scrollY={height}
                    loading={loading}
                    // pagination={pagination}
                    pagination={false}
                    onChange={this.handleChange}
                    columns={this.getColumns("kp")}
                    className="kpTable"
                    rowClassName={(record, index) => {
                        if(record.columnTitle.indexOf("合计") != -1){
                            return "bg_total";
                        }
                    }}
                />
                
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/RequestSheet/TablePage/List.js